import * as React from 'react';
import {Button, Dialog, DialogActions, DialogContent, DialogTitle, Typography} from '@mui/material';
import {useTranslation} from 'react-i18next';

export interface DeleteMonthlyChangeDialogProps {
    open: boolean;
    deleteItemId: string | null;
    setDeleteConfirmOpen: (open: boolean) => void;
    setDeleteItemId: (id: string | null) => void;
    handleDeleteMonthlyChange: (itemId: string) => Promise<void>;
}

export default function DeleteMonthlyChangeDialog({
    open,
    deleteItemId,
    setDeleteConfirmOpen,
    setDeleteItemId,
    handleDeleteMonthlyChange,
}: Readonly<DeleteMonthlyChangeDialogProps>): React.ReactElement {
    const {t} = useTranslation();
    return (
        <Dialog
            open={open}
            onClose={() => {
            }}
            disableEscapeKeyDown
        >
            <DialogTitle>{t('payroll.monthlyChange.dialog.deleteTitle')}</DialogTitle>
            <DialogContent>
                <Typography>{t('payroll.monthlyChange.dialog.deleteMessage')}</Typography>
            </DialogContent>
            <DialogActions>
                <Button onClick={() => setDeleteConfirmOpen(false)}>{t('common.actions.cancel')}</Button>
                <Button
                    color="error"
                    variant="contained"
                    onClick={async () => {
                        setDeleteConfirmOpen(false);
                        if (deleteItemId) {
                            await handleDeleteMonthlyChange(deleteItemId);
                            setDeleteItemId(null);
                        }
                    }}
                >
                    {t('common.actions.delete')}
                </Button>
            </DialogActions>
        </Dialog>
    );
}
